import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import router from './routes';
import { EnquiryProvider } from './context/EnquiryContext';
import { BannerProvider } from './context/BannerContext';
import { TestimonialProvider } from './context/TestimonialContext';
import { VideoProvider } from './context/VideoContext';
import { GalleryProvider } from './context/GalleryContext';
import { PropertyProvider } from './context/PropertyContext';
import { SettingsProvider } from './context/SettingsContext';
import { Provider } from 'react-redux';
import { store } from './store/store';

<link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap" rel="stylesheet"></link>

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <SettingsProvider>
        <EnquiryProvider>
          <BannerProvider>
            <TestimonialProvider>
              <VideoProvider>
                <GalleryProvider>
                  <PropertyProvider>

                    <RouterProvider router={router} />

                  </PropertyProvider>
                </GalleryProvider>
              </VideoProvider>
            </TestimonialProvider>
          </BannerProvider>
        </EnquiryProvider>
      </SettingsProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
